<template>
    <div class="align-middle w-full py-3">
        <h1 class="headline">
            <icon v-if="icon" v-bind:name="icon" class="h-6 w-6 inline mr-2 pb-1"/><slot/>
        </h1>
    </div>
</template>

<script>
    import Icon from '@/Shared/Icon';
    export default {
        components: {
            Icon
        },
        props: {
            title: String,
            icon: String
        }
    }
</script>
